import color from 'color';

function alpha(c, amount) {
  return color(c).alpha(amount).hsl().string();
}

export function createShadows(color) {
  var shadow = function shadow(amount) {
    return alpha(color, amount);
  };

  return {
    xs: "0 0 1px ".concat(shadow(0.1), ",\n    0 0 1px 1px ").concat(shadow(0.12), "\n  "),
    sm: "0 1px 8px 0 ".concat(shadow(0.15), ", \n    0 1px 3px 0 ").concat(shadow(0.1), ",\n    0 2px 3px -2px ").concat(shadow(0.12)),
    md: "0 1px 10px 0 ".concat(shadow(0.15), ", \n    0 6px 12px 0 ").concat(shadow(0.1), ",\n    0 6px 15px -2px ").concat(shadow(0.12)),
    lg: "0 1px 10px 0 ".concat(shadow(0.15), ", \n    0 15px 22px 0 ").concat(shadow(0.1), ",\n    0 15px 25px -2px ").concat(shadow(0.12)),
    xl: "0 1px 10px 0 ".concat(shadow(0.15), ", \n    0 25px 35px 0 ").concat(shadow(0.1), ",\n    0 25px 40px -2px ").concat(shadow(0.12))
  };
}
export function createDarkShadows(color) {
  var shadow = function shadow(amount) {
    return alpha(color, amount);
  };

  return {
    xs: "0 0 1px ".concat(shadow(0.15), ",\n    0 0 1px 1px ").concat(shadow(0.3), "\n  "),
    sm: "0 1px 8px 0 ".concat(shadow(0.24), ", \n    0 1px 3px 0 ").concat(shadow(0.13), ",\n    0 2px 3px -2px ").concat(shadow(0.16)),
    md: "0 1px 10px 0 ".concat(shadow(0.15), ", \n    0 6px 12px 0 ").concat(shadow(0.25), ",\n    0 6px 15px -2px ").concat(shadow(0.25)),
    lg: "0 1px 10px 0 ".concat(shadow(0.15), ", \n    0 15px 22px 0 ").concat(shadow(0.25), ",\n    0 15px 25px -2px ").concat(shadow(0.25)),
    xl: "0 1px 10px 0 ".concat(shadow(0.15), ", \n    0 25px 35px 0 ").concat(shadow(0.25), ",\n    0 25px 40px -2px ").concat(shadow(0.25))
  };
}